export class Device {
  uploadIntervalS: number = 100;
}